export default __webpack_public_path__ + "static/media/menu_simple.67629c9c.png";